import { useCallback, useState } from 'react';
import { useModalController, type UseModalControllerPayload } from './useModalController';

export interface UseOrderSubmissionErrorModalControllerPayload extends UseModalControllerPayload {
    onOpen: (description?: string) => void;
    errorDescription?: string;
}

export function useOrderSubmissionErrorModalController(): UseOrderSubmissionErrorModalControllerPayload {
    const modalProps = useModalController();
    const [errorDescription, setErrorDescription] = useState<string | undefined>(undefined);

    const onOpen = useCallback(
        (description?: string) => {
            setErrorDescription(description);
            modalProps.onOpen();
        },
        [modalProps]
    );

    return { ...modalProps, onOpen, errorDescription };
}
